import apartmentsAndOffices from '../../../images/components/GalleryWorkingObjects/content/apartments-and-offices.jpeg';
import shopsAndShoppingCenters from '../../../images/components/GalleryWorkingObjects/content/shops-and-shopping-centers.jpeg';
import fitnessCenters from '../../../images/components/GalleryWorkingObjects/content/fitness-centers.jpeg';
import swimmingPools from '../../../images/components/GalleryWorkingObjects/content/swimming-pools.jpeg';
import countryHousesCottagesTownhouses from '../../../images/components/GalleryWorkingObjects/content/country-houses-cottages-townhouses.jpeg';
import restaurantsCafesBars from '../../../images/components/GalleryWorkingObjects/content/restaurants-cafes-bars.jpeg';
import dentistryClinics from '../../../images/components/GalleryWorkingObjects/content/dentistry-clinics.jpeg';
import beautySalonsSpas from '../../../images/components/GalleryWorkingObjects/content/beauty-salons-spas.jpeg';

const listGalleryWorkingObjects = [
  {
    price: 'от 100 000',
    objectName: 'Квартиры и офисы',
    image: apartmentsAndOffices,
    alt: 'Изображение - изнутри люксовой квартиры',
  },

  {
    price: 'от 100 000',
    objectName: 'Магазины и ТЦ',
    image: shopsAndShoppingCenters,
    alt: 'Изображение - внутри торгового центра',
  },

  {
    price: 'от 150 000',
    objectName: 'Фитнес центры',
    image: fitnessCenters,
    alt: 'Изображение - внутри фитнес-центра',
  },

  {
    price: 'от 150 000',
    objectName: 'Бассейны',
    image: swimmingPools,
    alt: 'Изображение - встроенный бассейн',
  },
  {
    price: 'от 200 000',
    objectName: 'Загородные дома, коттеджи, таунхаусы',
    image: countryHousesCottagesTownhouses,
    alt: 'Изображение - люксового загородного дома',
  },
  {
    price: 'от 200 000',
    objectName: 'Рестораны, кафе, бары',
    image: restaurantsCafesBars,
    alt: 'Изображение - внутри ресторана',
  },

  {
    price: 'от 200 000',
    objectName: 'Стоматологии, клиники',
    image: dentistryClinics,
    alt: 'Изображение - внутри палаты клиники',
  },

  {
    price: 'от 100 000',
    objectName: 'Салоны красоты, СПА',
    image: beautySalonsSpas,
    alt: 'Изображение - внутри салона красоты',
  },
];

export { listGalleryWorkingObjects };
